// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__R4RKyiQb","tab":"Tabs_tab__efcsZk46","active":"Tabs_active__trs-nzel"};